import {Icon, LabelRegular, LabelSmallMedium, Pill, TextSemiBold} from '@hm/fundamental'
import {mdiChevronDown} from '@mdi/js'
import {Accordion, AccordionDetails, AccordionSummary} from '@mui/material'

import {formatDateTime, statusColor} from '../../helpers'
import {useRiskSurveyTranslation} from '../../hooks'
import type {AuditLogEntryDto} from '../../types'

type AuditLogSectionProps = {
  entries: AuditLogEntryDto[]
}

export const AuditLogSection = ({entries}: AuditLogSectionProps) => {
  const {t, i18n} = useRiskSurveyTranslation()

  return (
    <Accordion defaultExpanded={false} disableGutters elevation={0}>
      <AccordionSummary expandIcon={<Icon path={mdiChevronDown} size="regular" />}>
        <TextSemiBold>{t('auditLog.title')}</TextSemiBold>
      </AccordionSummary>
      <AccordionDetails>
        {entries.length === 0 ? (
          <LabelRegular className="text-foreground_faded">{t('auditLog.empty')}</LabelRegular>
        ) : (
          <div className="flex flex-col gap-3">
            {entries.map((entry) => (
              <div key={entry.id} className="pl-4 border-l-2 border-gray-300">
                <div className="flex items-center gap-2 flex-wrap">
                  {entry.previousStatus && (
                    <>
                      <Pill
                        type={statusColor[entry.previousStatus]}
                        text={entry.previousStatus}
                        size="regular"
                      />
                      <LabelRegular>→</LabelRegular>
                    </>
                  )}
                  <Pill type={statusColor[entry.newStatus]} text={entry.newStatus} size="regular" />
                </div>
                <LabelSmallMedium className="text-foreground_faded">
                  {entry.changedByUserName} · {formatDateTime(entry.changedAt, i18n.language)}
                </LabelSmallMedium>
                {entry.reason && (
                  <LabelRegular className="mt-1 italic">{entry.reason}</LabelRegular>
                )}
              </div>
            ))}
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  )
}
